import { useWindowSize } from '@confluence/dom-helpers';
import { useRenderServerPlaceholder } from '@confluence/ssr-utilities/entry-points/useRenderServerPlaceholder.ts';

import { TagButtonUIVariant } from '../constants/TagButtonUIVariant.ts';

type UseGetClassificationTagUIVariantArgs = {
	contentTitle?: string;
	classificationName?: string;
};

export const WINDOW_WIDTH_THRESHOLD = 1000;

export const useGetClassificationTagUIVariant = (
	_args: UseGetClassificationTagUIVariantArgs = {},
): TagButtonUIVariant => {
	const { width: windowWidth } = useWindowSize();
	const renderServerPlaceholder = useRenderServerPlaceholder();

	const isIconOnly = windowWidth < WINDOW_WIDTH_THRESHOLD;

	// window is not availble in SSR so we need to need to render
	// the icon only while hydrating
	return isIconOnly || renderServerPlaceholder
		? TagButtonUIVariant.iconOnly
		: TagButtonUIVariant.default;
};
